import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { VisiteeUpdateRequest } from "./VisiteeUpdateRequest";
import { VisiteeImportRequest } from "./VisiteeImportRequest";

@Injectable()
export class DataService_MultiStationVisiteeMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	VisiteeStaffSelectList(SchoolID, PersonTypeID, Active) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisiteeStaffSelectList?SchoolID=" + SchoolID + "&PersonTypeID=" + PersonTypeID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	StaffPersonTypeSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/StaffPersonTypeSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisiteeUpdateByTable(parms: VisiteeUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisiteeUpdateByTable";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	VisiteeImportInfoSelectList(parms: VisiteeImportRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/VisiteeImportInfoSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ExportFormatOptionSelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/ExportFormatOptionSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ExportSelectList(SchoolID, VisiteeExists, PersonTypeID, Active, HasEmail, HasPhoneNbr, FormatOptionID) {
		var postResult$ = new Subject();
		var url =
			"MultiStation/VisiteeExportSelectList?SchoolID=" +
			SchoolID +
			"&VisiteeExists=" +
			VisiteeExists +
			"&PersonTypeID=" +
			PersonTypeID +
			"&Active=" +
			Active +
			"&HasEmail=" +
			HasEmail +
			"&HasPhoneNbr=" +
			HasPhoneNbr +
			"&FormatOptionID=" +
			FormatOptionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
